// @flow
type UserInfo = {
  username: string,
  email: string,
  clientId: number,
  clientName: string,
};

window.satismeter =
  window.satismeter ||
  function() {
    (window.satismeter.q = window.satismeter.q || []).push(arguments);
  };
window.satismeter.l = +new Date();

export const SatisMeter = {
  load(): Promise<void> {
    return new Promise(resolve => {
      const script = document.createElement('script');
      script.async = true;
      document.head && document.head.appendChild(script);

      script.onload = resolve;
      script.onerror = () => {
        console.warn('Satismeter was not loaded');
        resolve();
      };
      script.src = 'https://app.satismeter.com/satismeter.js';
    });
  },

  showSurvey(props: UserInfo) {
    const { email, username, clientId, clientName } = props;
    window.satismeter({
      writeKey: '2E1t0tpRpqZD0QnW',
      userId: email,

      traits: {
        name: username,
        email,
        clientId,
        clientName,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/lib/satismeter.js